import React, { Fragment } from 'react';
import { getScoreClass } from '../../../../../functions/functions';
import MomioItemSponsored from '../../../momioItemSponsored';
import './rightBodyCardTenis.sass';

/**
 * Componente que representa el lado derecho de la tarjeta de tenis.
 * Muestra momios y resultados del partido según el estado del juego.
 */
export default function RightBodyCardTenis({ data, flagMomios, patrocinador }) {
  const { left_class, right_class, class: classGame, tenis_data } = data;
  const {left_stats, right_stats} = tenis_data;

  const showMomios = (flagMomios === "true" || flagMomios === true) && !["clarosports-finished-game", "clarosports-error-game"].includes(classGame);
  const isNext = classGame === "clarosports-next-game";
  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const metadata = data[`${patrocinadorKey}_metadata`] || {};

  /**
   * Renderiza los marcadores por sets con estilos según el estado del juego.
   */
  const renderMarcador = (position, scoreArray = [], teamClass) => {
    const baseScoreClass = `body-card-tenis__right-team-${position}-score`;
    const fullScoreClass = getScoreClass(baseScoreClass, teamClass, classGame);

    return (
      <div className={fullScoreClass}>
        {!isNext && Array.isArray(scoreArray) && scoreArray.length > 0 ? (
          scoreArray.map(({ set, score, is_higher, tiebreak }, index) => {
            let className = 'score-base';

            if (classGame === 'clarosports-finished-game') {
              // Finalizado: marcar al ganador global
              if (teamClass === 'clarosports-winner') {
                className += ' score-ganador-final';
              } else if (teamClass === 'clarosports-loser') {
                className += ' score-perdedor';
              } else {
                className += ' score-empate';
              }
            } else if (classGame === 'clarosports-in-progress-game') {
              // En progreso: marcar al ganador por set
              className += is_higher ? ' score-set-ganador' : ' score-set-normal';
            } else if (classGame === 'clarosports-next-game') {
              // Próximo: no pintar score, se gestiona fuera
              className += ' score-proximo';
            } else if (classGame === 'clarosports-error-game') {
              className += ' score-error';
            }
            
            // Validar si mostrar tiebreak comparando ambos equipos
            const leftTiebreak = left_stats.left_tenis_score[index]?.tiebreak || 0;
            const rightTiebreak = right_stats.right_tenis_score[index]?.tiebreak || 0;
            const shouldShowTiebreak = leftTiebreak > 0 || rightTiebreak > 0;

            return (
              <Fragment key={`${position}-set-${set}-${index}`}  >
              <span className={className}>
                {score}
              </span>
              {shouldShowTiebreak && <div className={className+"-tie"}><span>{tiebreak}</span></div>}
              </Fragment>
            );
          }))
          : (position !== 'middle' && <span className='score-base set-proximo'>-</span>)
        }
      </div>
    );
  };

  return (
    <>
      {/* Momios */}
      <div className='body-card-tenis__right-momios'>
        <MomioItemSponsored position="left" metadata={metadata} showMomios={showMomios} baseClass="body-card-tenis__right-team" />
        <MomioItemSponsored position="middle" metadata={metadata} showMomios={showMomios} baseClass="body-card-tenis__right-team" />
        <MomioItemSponsored position="right" metadata={metadata} showMomios={showMomios} baseClass="body-card-tenis__right-team" />
      </div>

      {/* Marcadores */}
      <div className='body-card-tenis__right-score'>
        {renderMarcador('left', left_stats?.left_tenis_score, left_class)}
        {renderMarcador('right', right_stats?.right_tenis_score, right_class)}
      </div>
    </>
  );
}